module.exports = __webpack_public_path__ + "img/northen-cyprus.4b859f93.svg";